import styled from 'styled-components';
import { NavLink as LinkN, Link } from 'react-router-dom';

export const NavBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 22.5%; 
    min-width: 225px; 
 /* width: fit-content;*/
    height: calc(100vh - 45px);
    padding: 2rem 1rem 0rem 3rem;
    position: sticky;
    top: 0;

    @media (max-width: ${({ theme }) => theme.size.laptopL}) {
        width: 100%;
        position: initial;
        height: fit-content;
         padding: 0rem 3rem 0rem 1rem;
    }
`
export const NavHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 2rem;
`
export const NavLogo = styled(Link)`
    display: flex;
    width: 182px;
    height: 100px;
    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    @media (max-width: ${({theme}) => theme.size.laptopL}) {
        height: 40px;
    }
`
export const ReduceIcon = styled.div`
    display: flex;
    background-color: #ffffff;
    color: #505050 !important;
    border-radius: 50%;
    padding: 0.5rem;
    cursor: pointer;
`;

export const NavMenu = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    flex: 1;
    padding: 0;
    margin: 0;
    width: 100%;
    font-size: 0.9rem;

     @media (max-width: ${({ theme }) => theme.size.laptopL}) {
        font-size: 0.8rem;
        flex-direction: row;
        justify-content: space-around;
        background: #fefefe;
        padding: 10px 6px 4px 0px;
        border-radius: 6px;
        box-shadow: 1px 1px 4px 2px #dfdfdf;
        margin-bottom: 10px;
    }
`

export const NavItem = styled.li`
    margin: 0;
    width: 100%;
    margin-bottom: 0.5rem;
      @media (max-width: ${({ theme }) => theme.size.laptopL}) {
        padding-left: 5px;
     
        }
`

export const NavLink = styled(LinkN)`
    display: flex;
    align-items: center;
    width: 100%;
    height: 59px;
    /* background-color: #2174B9; */
    border-radius: 40px 0px;
    color: ${({theme}) => theme.colors.secondary};
    text-decoration: none;
    padding: 0 30px;

    & span {
        font-weight: 500;
        margin-left: 1rem;
    }

    &:hover {
        background-color: ${({theme}) => theme.colors.primary};
        color: #ffffff;
        transition: all 0.5s ease-in-out;
    }

    &.${({activeClassName}) => activeClassName} {
        background-color: ${({theme}) => theme.colors.primary};
        color: #ffffff;
    }

    @media (max-width: ${({theme}) => theme.size.laptopL}) {
        height: 40px;

        & span {
            margin-left: 1rem;
        }
    }
`

export const NavBtn = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 45px;
    border: 1px solid rgba(0, 0, 0, 0.125);
    background-color: ${({isActive, theme}) => isActive ? theme.colors.primary : theme.colors.body};
    border-radius: 10px 0px 10px 0px;
    color:${({ isActive, theme }) => isActive ? '#fff' : '#344767'}; ;
  
    text-decoration: none;
    padding: 0 1px;
    cursor: pointer;
    font-weight: 500;
    & span {
        font-size:1rem;
        
        margin-left: 1rem;
    }

    &:hover {
        background-color: ${({theme}) => theme.colors.primary};
        color: #ffffff;
        transition: all 0.5s ease-in-out;
    }

    @media (max-width: ${({theme}) => theme.size.laptopL}) {
        height: 40px;

        & span {
           
             font-size:0.8rem;
        }
    }
`

export const NavIcon = styled.div`
    margin-bottom: 6px;

    @media (max-width: ${({theme}) => theme.size.laptopL}) {
        & svg {
            width: 20px;
        }
    }
`

export const NavFooter = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    color: ${({theme}) => theme.size.primary} !important;
    font-size: 0.9rem;
    & p {
        color: ${({theme}) => theme.size.primary} !important;
    }
   @media (max-width: ${({ theme }) => theme.size.laptopL}) {
        font-size: 0.8rem;
        display:none;
    }

`